import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as constants from "./constants";

interface IState extends IDefaultState<any, any, any> {
  [constants.TERRITORY_ASSIGNMENT_TERRITORIES_LOADING]: boolean;
  [constants.TERRITORY_ASSIGNMENT_TERRITORIES]: any[];

  [constants.TERRITORY_ASSIGNMENT_USERS_LOADING]: boolean;
  [constants.TERRITORY_ASSIGNMENT_USERS]: any[];
}

const initialState:IState = {
    ...defaultInitialState,
    [constants.TERRITORY_ASSIGNMENT_TERRITORIES_LOADING]: false,
    [constants.TERRITORY_ASSIGNMENT_TERRITORIES]: [],

    [constants.TERRITORY_ASSIGNMENT_USERS_LOADING]: false,
    [constants.TERRITORY_ASSIGNMENT_USERS]: [],
};
const reducers = {
  ...defaultReducers,
  setTerritoryAssignmentTerritoriesLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.TERRITORY_ASSIGNMENT_TERRITORIES_LOADING] = action.payload;
  },
  setTerritoryAssignmentTerritories: (state:IState, action:PayloadAction<any[]>) => {
    state[constants.TERRITORY_ASSIGNMENT_TERRITORIES] = action.payload;
  },


  setTerritoryAssignmentUsersLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.TERRITORY_ASSIGNMENT_USERS_LOADING] = action.payload;
  },
  setTerritoryAssignmentUsers: (state:IState, action:PayloadAction<any[]>) => {
    state[constants.TERRITORY_ASSIGNMENT_USERS] = action.payload;
  }
};

export const territoryAssignmentsSlice = createSlice({
  name: "territoryAssignments",
  initialState,
  reducers,
});

